import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

/* Layout */
import Layout from '@/layout'
import EmptyView from "@/layout/components/EmptyView.vue"
let wuHidden = !localStorage.getItem('is_wu_user')
if (location.href.indexOf('deliver/import/print') !== -1) {
  wuHidden = false
}

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    // name: 'Dashboard',
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/home/index'),
        name: 'homeDashboard',
        meta: { title: '首页', icon: 'home', affix: true }
      }
    ]
  }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  {
    path: '/deliver',
    component: Layout,
    redirect: '/deliver/index',
    name: 'Deliver',
    meta: { title: '打单发货', icon: 'print' },
    children: [
      {
        path: 'pending',
        component: () => import('@/views/deliver/pending'),
        name: 'DeliverPending',
        meta: { title: '待发货订单', icon: 'aperture', permissionCode: 'nv.deliver.print.wait' }
      },
      {
        path: 'print',
        component: () => import('@/views/deliver/print'),
        name: 'DeliverPrint',
        meta: { title: '预打印发货', icon: 'aperture', permissionCode: 'nv.deliver.beforehand.print' }
      },
      // {
      //   path: 'freedom',
      //   component: () => import('@/views/deliver/freedom'),
      //   name: 'DeliverFreedom',
      //   meta: { title: '自由打单', icon: 'aperture', permissionCode: 'nv.deliver.print.freedom' }
      // },
      {
        path: 'order',
        component: () => import('@/views/deliver/order'),
        name: 'DeliverOrder',
        meta: { title: '导入发货', icon: 'aperture', permissionCode: 'nv.deliver.send.import' }
      },
      {
        path: 'record',
        component: () => import('@/views/operation/record'),
        name: 'OperRecord',
        meta: { title: '回收/补打', icon: 'aperture', permissionCode: 'nv.operation.record' }
      },
      // {
      //   path: 'import/print',
      //   component: () => import('@/views/deliver/importPrint'),
      //   name: 'ImportPrint',
      //   meta: { title: '物流发货', icon: 'aperture' },
      //   hidden: wuHidden
      // },
      {
        path: 'dashboard4',
        component: () => import('@/views/dashboard/index'),
        name: 'Dashboard4',
        meta: { title: '发货单打印', icon: 'aperture' },
        hidden: true
      },
      {
        path: 'dashboard5',
        component: () => import('@/views/dashboard/index'),
        name: 'Dashboard5',
        meta: { title: '备货单打印', icon: 'aperture' },
        hidden: true
      },
      // {
      //   path: 'behalfOfOthers',
      //   component: EmptyView,
      //   redirect: '/setting/index',
      //   name: 'behalfOfOthers',
      //   meta: { title: '厂家代发', icon: 'aperture', permissionCode: 'nv.deliver.print.wait' },
      //   children: [
      //     {
      //       path: 'index',
      //       component: () => import('@/views/deliver/behalfOfOthers'),
      //       name: 'behalfOfOthersMain',
      //       meta: { title: '厂家代发', icon: 'aperture', permissionCode: 'nv.deliver.print.wait' }
      //     },
      //     {
      //       path: 'print',
      //       component: () => import('@/views/deliver/printNew'),
      //       name: 'printNew',
      //       meta: { title: '预发货订单', icon: 'aperture', permissionCode: 'nv.deliver.beforehand.print' }
      //     }
      //   ]
      // },
      {
        path: 'printOrderList',
        component: () => import('@/views/deliver/components/printOrderList'),
        name: 'printOrderList',
        meta: { title: '预打印发货详情', icon: 'aperture' },
        hidden: true
      }
      // {
      //   path: 'storeLog',
      //   component: () => import('@/views/deliver/storeLog'),
      //   name: 'storeLog',
      //   meta: { title: '代发货的店铺日志', icon: 'aperture', permissionCode: 'nv.deliver.print.wait' }
      // }
    ]
  },
  // {
  //   path: '/behalfOfOthers',
  //   component: Layout,
  //   redirect: '/behalfOfOthers/index',
  //   name: 'behalfOfOthers',
  //   meta: { title: '厂家代发', icon: 'aperture' },
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/deliver/behalfOfOthers'),
  //       name: 'behalfOfOthersMain',
  //       meta: { title: '厂家代发', icon: 'aperture', permissionCode: 'nv.deliver.print.wait' }
  //     },
  //     {
  //       path: 'print',
  //       component: () => import('@/views/deliver/printNew'),
  //       name: 'printNew',
  //       meta: { title: '预发货订单', icon: 'aperture', permissionCode: 'nv.deliver.beforehand.print' }
  //     }
  //   ]
  // },
  {
    path: '/setting',
    component: Layout,
    redirect: '/setting/index',
    name: 'Setting',
    meta: { title: '打印设置', icon: 'printset', permissionCode: 'nv.setting' },
    children: [
      {
        path: 'template',
        component: () => import('@/views/setting/templateNew'),
        name: 'SettingTemplate',
        meta: { title: '快递模板', icon: 'el-icon-tickets', permissionCode: 'nv.setting.template' }
      },
      {
        path: 'invoice',
        component: () => import('@/views/setting/invoices'),
        name: 'SettingInvoice',
        meta: { title: '发货单模板', icon: 'el-icon-document', permissionCode: 'nv.setting.invoice' }
      },
      {
        path: 'express',
        component: () => import('@/views/shop/express'),
        name: 'Documentation3',
        meta: { title: '电子面单账号', icon: 'aperture' }
      },
      {
        path: 'setaddress',
        component: () => import('@/views/print/setAddress'),
        name: 'SendAddressManage',
        meta: { title: '发货地址设置', icon: 'aperture', permissionCode: 'nv.setting.setAddress' }
      },
      {
        path: 'picking',
        component: () => import('@/views/setting/picking'),
        name: 'settingPicking',
        meta: { title: '备货单模板', icon: 'aperture', permissionCode: 'nv.setting.picking' }
      }
    ]
  },
  {
    path: '/shop',
    component: Layout,
    alwaysShow: true,
    redirect: '/shop/list',
    name: 'Shop',
    meta: { title: '店铺管理', icon: 'management', permissionCode: 'nv.shop', noCache: true },
    children: [
      {
        path: 'index1',
        component: () => import('@/views/guide/index'),
        name: 'Guide1',
        meta: { title: '面单共享', icon: 'aperture', noCache: true },
        hidden: true
      },
      {
        path: 'list',
        component: () => import('@/views/shop/list'),
        name: 'ShopList',
        meta: { title: '店铺管理', icon: 'el-icon-s-shop', permissionCode: 'nv.shop.list', noCache: true }
      },
      {
        path: 'set',
        component: () => import('@/views/shop/set'),
        name: 'shopSet',
        meta: { title: '商品设置', icon: 'aperture', permissionCode: 'nv.shop.set', noCache: true },
        hidden: true
      },
      {
        path: 'after',
        component: () => import('@/views/shop/after'),
        name: 'ShopAfter',
        meta: { title: '售后订单', icon: 'aperture', permissionCode: 'nv.shop.after', noCache: true }
      },
      // {
      //   path: 'after-sale',
      //   component: () => import('@/views/shop/afterSaleAddress'),
      //   name: 'ShopAfterSale',
      //   meta: { title: '售后地址', icon: 'el-icon-map-location', noCache: true }
      // },
      // {
      //   path: 'express',
      //   component: () => import('@/views/shop/express'),
      //   name: 'ShopExpress',
      //   meta: { title: '店铺快递', icon: 'aperture', permissionCode: 'nv.shop.express', noCache: true }
      // },
      {
        path: 'share',
        component: () => import('@/views/shop/share'),
        name: 'ShopShare',
        meta: { title: '面单共享', icon: 'aperture', noCache: true, permissionCode: 'nv.shop.share' }
      }
    ]
  },
  {
    path: '/operation',
    component: Layout,
    alwaysShow: true,
    redirect: '/operation/record',
    // hidden: true,
    name: 'operationRe',
    meta: { title: '操作日志', icon: 'operation', permissionCode: 'nv.operation' },
    children: [
      {
        path: 'print',
        component: () => import('@/views/operation/print'),
        name: 'PrintLog',
        meta: { title: '打印日志', icon: 'aperture', permissionCode: 'nv.operation.print' }
      },
      {
        path: 'index2',
        component: () => import('@/views/operation/print'),
        name: 'WaybillCodeLog',
        meta: { title: '取号日志', icon: 'aperture', permissionCode: 'nv.operation.print' },
        hidden: true
      },
      {
        path: 'record',
        component: () => import('@/views/operation/record'),
        name: 'OperRecord',
        meta: { title: '取号记录', icon: 'aperture', permissionCode: 'nv.operation.record' }
      }
    ]
  },
  {
    path: '/statistics',
    component: Layout,
    redirect: '/permission/page',
    alwaysShow: true, // will always show the root menu
    name: 'Permis',
    meta: {
      title: '统计对账',
      icon: 'statistics2'
      // roles: ['admin', 'editor'] // you can set roles in root nav
    },
    hidden: true,
    children: [
      {
        path: 'page',
        component: () => import('@/views/permission/page'),
        name: 'PagePermission',
        meta: {
          title: '面单对账',
          icon: 'aperture'
          // roles: ['admin'] // or you can only set roles in sub nav
        }
      },
      {
        path: 'delivery',
        component: () => import('@/views/statistics/delivery'),
        name: 'statisticsDdelivery',
        meta: {
          title: '快递对账',
          icon: 'aperture'
          // if do not set roles, means: this page does not require permission
        }
      },
      {
        path: 'role',
        component: () => import('@/views/permission/role'),
        name: 'RolePermission',
        meta: {
          title: '销售统计',
          icon: 'aperture'
        }
      }
    ]
  },

  {
    path: '/more',
    component: Layout,
    redirect: '/more/index',
    alwaysShow: true,
    name: 'MoreMenu',
    meta: {
      title: '更多功能',
      icon: 'component',
      permissionCode: 'nv.more'
      // if do not set roles, means: this page does not require permission
    },
    children: [
      {
        path: 'admin',
        component: () => import('@/views/admin/setting'),
        name: 'AdminSetting',
        meta: { title: '子账号设置', icon: 'peoples', permissionCode: 'nv.more.admin.setting' }
      },
      {
        path: 'balance',
        component: () => import('@/views/setting/balance'),
        name: 'MallBalance',
        meta: { title: '余额管理', icon: 'aperture' }
      }
    ]
  }
]

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    mode: process.env.NODE_ENV === 'production' ? 'history' : 'hash',
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
